import * as userAction from "../actions/nearby.action";
const user = (
  state = {
    status: null,
    loading: false,
    error: null,
    nearby: null,
  },
  action,
) => {
  switch (action.type) {
    case userAction.NEARBY_REQUEST:
      return Object.assign({}, state, {
        status: action.status,
        loading: true,
      });
    case userAction.NEARBY_SUCCESS:
      return Object.assign({}, state, {
        nearby: action.nearby,
        status: action.status,
        loading: false,
      });
    case userAction.NEARBY_FAILURE:
      return Object.assign({}, state, {
        error: action.error,
      });
    default:
      return state;
  }
};
export default user;
